import { useL10n } from './context';

export function useCountryCode(): string {
	return useL10n().countryCode;
}
